import { useEffect, useRef } from 'react';
import { CableConsumer } from 'lib/cable_consumer';

// Subscribes to an ActionCable channel and resubscribes only when the channel
// changes. The received callback is kept fresh through a ref, so callers can
// pass a new closure on every render without tearing down the subscription.
// Pass a null channel to skip subscribing (e.g. until the component can receive).
export function useChannel<T>(channel: string | null, received: (data: T) => void) {
  const receivedRef = useRef(received);
  receivedRef.current = received;

  useEffect(() => {
    if (!channel) {
      return undefined;
    }

    const subscription = CableConsumer.subscriptions.create(
      { channel },
      { received: (data: T) => receivedRef.current(data) }
    );

    return () => subscription.unsubscribe();
  }, [channel]);
}
